import api from "./api";
import { APIS } from "../endpoints";

/**
 * This function return songs data
 * @returns {Promise<Object>} - Function return Songs data
 */
export const getColorAliasSuggestions = async (limit, page, inputValue) => {
    const formData = new FormData();
    formData.append('page', page);
    formData.append('limit', limit);

    if (inputValue) {
        formData.append('search', inputValue); // Add search term
    }

    const params = new URLSearchParams(formData);
    const result = await api.get(`${APIS.BASE_URL}${APIS.colorlistAliasSuggestions}`, {
        params: params
    })

    if (result) {
        return result?.data;
    } else {
        return [];
    }
};

export const getLanguageAliasSuggestions = async (limit, page, inputValue) => {
    const formData = new FormData();
    formData.append('page', page);
    formData.append('limit', limit);

    if (inputValue) {
        formData.append('search', inputValue); // Add search term
    }

    const params = new URLSearchParams(formData);
    const result = await api.get(`${APIS.BASE_URL}${APIS.languageAliasSuggestions}`, {
        params: params
    })

    if (result) {
        return result?.data;
    } else {
        return [];
    }
};